export type Hex = `#${string}`;

export const EDGE_COLORS = {
    dobermanBlack: "#1f0e01",
    malteseWhite: "#fffbf7",
    trueWhite: "#ffffff",
    black: "#281300",
    trueBlack: "#000000",
    labradorYellow: "#ffba47",
} as const;

const SCRIM_COLORS = {
    "doberman-black": EDGE_COLORS.dobermanBlack,
    black: EDGE_COLORS.black,
    "true-black": EDGE_COLORS.trueBlack,
} as const;

type ScrimColor = keyof typeof SCRIM_COLORS;

export type ScrimClassName = `bg-${ScrimColor}` | `bg-${ScrimColor}/${number}`;

export type EdgeTint = { color: Hex; alpha: number };

export type EdgeScrim = { className: ScrimClassName; tint: EdgeTint };

export function edgeScrim(className: ScrimClassName): EdgeScrim {
    const [color, percent = "100"] = className.slice("bg-".length).split("/");
    return {
        className,
        tint: {
            color: SCRIM_COLORS[color as ScrimColor],
            alpha: Number(percent) / 100,
        },
    };
}

export const EDGE_BLEND_PX = 80;

function clampUnit(value: number): number {
    return Math.max(0, Math.min(1, value));
}

export function mixHex(from: Hex, to: Hex, amount: number): Hex {
    const progress = clampUnit(amount);
    return `#${[1, 3, 5]
        .map((index) => {
            const start = Number.parseInt(from.slice(index, index + 2), 16);
            const end = Number.parseInt(to.slice(index, index + 2), 16);
            return Math.round(start + (end - start) * progress)
                .toString(16)
                .padStart(2, "0");
        })
        .join("")}`;
}

export function smoothstep(progress: number): number {
    const clamped = clampUnit(progress);
    return clamped * clamped * (3 - 2 * clamped);
}

export function blendAcross(
    from: Hex,
    to: Hex,
    distancePx: number,
    spanPx = EDGE_BLEND_PX,
): Hex {
    return mixHex(from, to, smoothstep(distancePx / spanPx));
}
